<app-header></app-header>
<div class="content" role="dialog" attr.aria-label="{{ 'sessiontimeout.modalTitle' | translate }}"
    attr.aria-describedby="{{ 'sessiontimeout.desc' | translate }}">
    <div class="content-margin">
        <div class="col-xl-12 col-lg-11 col-md-11 col-sm-11 mx-auto">
            <h2 class="mt-5" attr.aria-label="{{ 'sessiontimeout.timeouttitle' | translate }}">
                {{ "sessiontimeout.timeouttitle" | translate }}</h2>


            <p class="mt-4">
                <a role="link" href="{{ 'sessiontimeout.link' | translate }}"
                    attr.aria-label="{{'otherdata.clicklink' | translate}}{{ 'sessiontimeout.timeoutheading' | translate }}">
                    {{ "sessiontimeout.timeoutheading" | translate }}</a>
            </p>

        </div>
    </div>
</div>